<template>
    <div v-if="features" class="tab-pane" id="features-tab" v-html="features">
    </div>
</template>

<script>
    export default {
        computed:{
            features(){
                if(typeof this.$store.getters.currentItemVariation.variationProperties !== 'undefined'){
                    const details =  this.$store.getters.currentItemVariation.variationProperties[0].properties.find(prop => prop.propertyId === 9);
                    if(!details){
                        return false;
                    } else {
                        return details.values.value;
                    }
                }else{
                    return false;
                }
            }
        }
    }
</script>
